export default __webpack_public_path__ + "static/media/post_step1.251fa211.png";